import React, { useState } from 'react'

import { Button } from '@leasequery/lq.react-component-library'

import '../form/RitForm.css'

export default function LeaseName({
	navigateForward,
	content,
	errorMessage,
	value,
}) {
	const [leaseName, setLeaseName] = useState(value)

	return (
		<div>
			<div className='form'>
				<input
					type='text'
					name='name'
					value={leaseName ? leaseName : ''}
					onChange={(e) => {
						setLeaseName(e.target.value)
					}}
					required
				/>
				<label htmlFor='name' className='label-name'>
					<span className='content-name'>{content}</span>
				</label>
			</div>
			<div className='errorMessage-Container'>{errorMessage}</div>
			<div>
				<Button
					buttonType='primary'
					className='form-Button'
					onClick={() => navigateForward(leaseName)}
				>
					Next
				</Button>
			</div>
		</div>
	)
}
